'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Block = require('./Block');

var _Block2 = _interopRequireDefault(_Block);

var _Input = require('../inputs/Input');

var _Input2 = _interopRequireDefault(_Input);

var _Textarea = require('../inputs/Textarea');

var _Textarea2 = _interopRequireDefault(_Textarea);

var _RadioSelect = require('../inputs/RadioSelect');

var _RadioSelect2 = _interopRequireDefault(_RadioSelect);

var _Checkbox = require('../inputs/Checkbox');

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _DatePicker = require('../inputs/DatePicker');

var _DatePicker2 = _interopRequireDefault(_DatePicker);

var _Select = require('../inputs/Select');

var _Select2 = _interopRequireDefault(_Select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// import Select from '../../utils/inputs/Select'


var mapInputComps = {
  text: _Input2.default,
  number: _Input2.default,
  textarea: _Textarea2.default,
  date: _DatePicker2.default,
  radio: _RadioSelect2.default,
  select: _Select2.default,
  checkbox: _Checkbox2.default
};

function getDefaultInput(_ref) {
  var type = _ref.type,
      options = _ref.options;

  if (options) return 'select';
  if (type === 'ObjectId') return 'select';
  if (type === 'Array') return 'select';
  if (type === 'Date') return 'date';
  if (type === 'Number') return 'number';
  if (type === 'Boolean') return 'checkbox';

  return 'text';
}

function getEditorInput(props) {
  var input = props.input || getDefaultInput(props);
  return props.Input || mapInputComps[input];
}

function InputBlock(props) {
  var config = props.config,
      Input = props.Input,
      passing = _objectWithoutProperties(props, ['config', 'Input']);

  var merged = _extends({}, props.schema, props);
  var required = merged.required,
      name = merged.name,
      type = merged.type,
      options = merged.options,
      input = merged.input;


  var InputComp = getEditorInput({ input: input, Input: Input, type: type, options: options });
  return _react2.default.createElement(
    _Block2.default,
    _extends({ name: name, required: required }, config),
    _react2.default.createElement(InputComp, passing)
  );
}

var element = _propTypes2.default.element,
    object = _propTypes2.default.object,
    string = _propTypes2.default.string;

InputBlock.propTypes = {
  config: object,
  Input: element,
  input: string,
  schema: object
};

exports.default = InputBlock;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/DocEditor/InputBlock.js
// module id = 1722
// module chunks = 0